import styled from 'styled-components';
import { white } from '../../../../style/colors';

export const Card = styled.div`
  background: ${white};
  border: 1px solid #e5e7eb;
  border-radius: 12px;
  padding: 16px;
  transition: all 0.2s;
  display: flex;
  flex-direction: column;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
    border-color: #d1d5db;
  }
`;

export const IconWrapper = styled.div`
  width: 48px;
  height: 48px;
  border-radius: 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 12px;
  background: ${(props) => props.bgColor};

  i {
    font-size: 24px;
    color: ${(props) => props.iconColor};
  }
`;

export const Info = styled.div`
  flex: 1;
`;

export const Name = styled.h4`
  font-size: 14px;
  font-weight: 600;
  color: #111827;
  margin: 0 0 4px 0;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const Meta = styled.div`
  font-size: 12px;
  color: #6b7280;
  margin-bottom: 12px;
`;

export const Actions = styled.div`
  display: flex;
  gap: 8px;
  padding-top: 12px;
  border-top: 1px solid #f3f4f6;
`;

export const ActionButton = styled.button`
  background: transparent;
  border: 1px solid #e5e7eb;
  padding: 8px 12px;
  cursor: pointer;
  color: #6b7280;
  border-radius: 6px;
  transition: all 0.2s;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
  font-size: 13px;

  &:hover {
    background: #f9fafb;
    color: #111827;
    border-color: #d1d5db;
  }

  i {
    font-size: 16px;
  }
`;
